import { Link } from 'react-router-dom';
import styles from '../styles/home.module.css';

function Home() {
  return (
    <>
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <div className={styles.textContent}>
            <h1 className={styles.title}>
              Transform Your Future
              <br />
              Through Technology
            </h1>
            <p className={styles.subtitle}>
              Join our premium tech education programs designed to elevate your skills and
              accelerate your career growth
            </p>
            <Link to="/programs" className={styles.ctaButton}>
              Explore Programs
            </Link>
          </div>
          <div className={styles.imageContainer}>
            <img src="/images/inspire.png" alt="Inspire" className={styles.heroImage} />
          </div>
        </div>
      </section>
      <div className={styles.programsContainer}>
        <h3 className={styles.programsTitle}>EXPERTS FROM</h3>
        <div className={styles.logoContainer}>
          <img src="/images/amazon2.png" alt="Amazon" className={styles.logo} />
          <img src="/images/Google.png" alt="Google" className={styles.logo} />
          <img src="/images/Infosys.png" alt="Infosys" className={styles.logo} />
          <img src="/images/Microsoft.png" alt="Microsoft" className={styles.logo} />
          <img src="/images/deloitte.png" alt="Deloitte" className={styles.logo} />
          <img src="/images/DAZN.png" alt="DAZN" className={styles.logo} />
          <img src="/images/Medtronic.png" alt="Medtronic" className={styles.logo} />
        </div>
      </div>
      <section className={styles.featuredSection}>
        <div className={styles.featuredGrid}>
          {featuredPrograms.map(program => (
            <div
              key={program.id}
              className={`${styles.programCard} ${!program.active ? styles.inactiveCard : ''}`}
            >
              {!program.active && <div className={styles.comingSoonBanner}>Coming Soon</div>}
              <img src={program.image} alt={program.title} className={styles.programImage} />
              <div className={styles.programContent}>
                <h3 className={styles.programTitle}>{program.title}</h3>
                <p className={styles.programDescription}>{program.description}</p>
                {program.active ? (
                  <Link to={`/program/${program.id}`} className={styles.learnMore}>
                    Learn More
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ marginLeft: '8px' }}
                    >
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </Link>
                ) : (
                  <span className={styles.learnMore}>Coming Soon</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

const featuredPrograms = [
  {
    id: 3,
    title: 'Full-Stack Engineering',
    description: 'Master modern web development with React, Node.js, and cloud technologies',
    image: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=800',
    active: true,
  },
  {
    id: 2,
    title: 'Data Science & AI',
    description: 'Build real-world AI solutions using Python, TensorFlow, and advanced analytics',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=800',
    active: false,
  },
  {
    id: 3,
    title: 'Cloud Architecture',
    description: 'Design and implement scalable solutions using AWS, Azure, and GCP',
    image: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=800',
    active: false,
  },
];

export default Home;
